






















import { templateListInstance } from '@/model/ModuleTemplateListClass';
import { Component, Vue } from 'vue-property-decorator';

type IModuleTemplateInfo = IModule.IResponse.IModuleTemplateInfo;

@Component({
  components: {},
})
export default class TemplateListModal extends Vue {
  private visible = false;
  private templateListInstance = templateListInstance;
  get templateListData() {
    return this.templateListInstance.list.data.filter((item) => item.status === 'Processing');
  }
  get columns() {
    const titleColumn = {
      slots: { title: 'templateTitle' },
      dataIndex: 'moduleTitle',
      // width: '22%',
      ellipsis: true,
    };
    const projectColumn = {
      slots: { title: 'projectTitle' },
      dataIndex: 'projectName',
      width: '20%',
    };
    const commentColumn = {
      dataIndex: 'comment',
      slots: { title: 'commentTitle' },
      // width: '58%',
    };
    const actionColumn = {
      key: 'action',
      scopedSlots: { customRender: 'action' },
      width: '15%',
    };
    return [
      titleColumn,
      projectColumn,
      commentColumn,
      actionColumn,
    ];
  }
  public showModal() {
    this.visible = true;
  }
  public closeModal() {
    this.visible = false;
  }
  private selectTemplate(template: IModuleTemplateInfo) {
    this.templateListInstance.changeModuleParams(template);
    this.$router.push({
      name: 'CreateModuleFromTemplate',
    });
    this.closeModal();
  }
}
